import { useTranslation } from 'react-i18next';
import { Text, Modal, Button } from '@hotjar/hotsauce';
import { capitalize } from '@hotjar/insights-common/lib/string';

export interface RefreshScreenshotModalProps {
  isSelectedDateRangeAbsolute: boolean;
  isOpen: boolean;
  onCancelOrClose: () => void;
  onRefreshScreenshot: () => void;
}

export const RefreshScreenshotModal = ({
  isSelectedDateRangeAbsolute,
  isOpen,
  onCancelOrClose,
  onRefreshScreenshot,
}: RefreshScreenshotModalProps): JSX.Element => {
  const { t } = useTranslation('heatmaps');

  return (
    <Modal
      size="s"
      isOpen={isOpen}
      onClose={onCancelOrClose}
      contentLabel={t('refresh-screenshot-modal.content-label')}
    >
      <Modal.Header title={t('refresh-screenshot-modal.header')} />
      <Modal.Body>
        <Text as="p">
          {t('refresh-screenshot-modal.message', {
            context: isSelectedDateRangeAbsolute ? 'absolute_date_range' : null,
          })}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={onCancelOrClose}>
          {capitalize(t('general-terms.cancel'))}
        </Button>
        <Button kind="primary" onClick={onRefreshScreenshot}>
          {capitalize(t('general-terms.refresh'))}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
